function StudentsHeader() {
  return <div className="text-sm flex flex-row justify-center">Students</div>;
}

export default StudentsHeader;
